import { t } from "../services/utils";
import React from "react";
import { primary5 } from "../constants/colors";
import { Button, Paper } from "@material-ui/core";
import IconMoon from "./IconMoon";

interface OnboardingCardProps {
  img: string;
  title: string;
  description: string;
  buttonLabel?: string;
  onBtnClick?: () => void;
  onClose?: () => void;
  isLearnMore?: boolean;
  onLearnMoreBtnClick?: () => void;
  style?: React.CSSProperties;
}

export default function OnboardingCard({
  img,
  title,
  description,
  buttonLabel,
  onBtnClick,
  isLearnMore = false,
  onLearnMoreBtnClick,
  style,
}: OnboardingCardProps) {
  const styles = {
    container: {
      backgroundColor: primary5,
      border: "10px solid #FFFFFF",
      borderRadius: 10,
      display: "flex" as const,
      flexDirection: "column" as const,
      color: "#2A234E",
      boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
      marginBottom: 40
    },
    innerContainer: {
      padding: 30,
      display: "flex" as const,
      flexDirection: "row" as const,
      alignItems: "center" as const
    },
    contentContianer: {
      marginLeft: 40
    },
    image: {
      width: 180
    },
    ctaContainer: {
      marginTop: 30,
      display: "flex" as const,
      flexDirection: "row" as const,
      alignItems: "center" as const
    },
    ctaButton: {
      height: 40,
      marginRight: 10
    },
    title: {
      fontWeight: "600",
      fontSize: 22,
      lineHeight: "28px"
    },
    description: {
      marginTop: 12,
      fontSize: 16,
      lineHeight: "24px"
    }
  };
  return <Paper elevation={1} style={{
    ...styles.container,
    ...style
  }}>
      <div style={styles.innerContainer}>
        <img style={styles.image} src={img} />
        <div style={styles.contentContianer}>
          <div style={styles.title}>{title}</div>
          <div style={styles.description}>{description}</div>
          <div style={styles.ctaContainer}>
            {buttonLabel && <Button variant="contained" color="primary" style={styles.ctaButton} onClick={onBtnClick} startIcon={<IconMoon icon="add" color="white" />}>
              {buttonLabel}
            </Button>}
            {isLearnMore && <Button variant="contained" color="primary" style={styles.ctaButton} onClick={onLearnMoreBtnClick}>{t("learnMore")}</Button>}
          </div>
        </div>
      </div>
    </Paper>;
}